import { NgModule } from '@angular/core';
import { AdHocLayoutComponent } from './ad-hoc-layout.component';
import { SharedModule } from '../_shared/shared.module';

@NgModule({
    imports: [SharedModule, AdHocLayoutComponent],
})
export class AdHocModule {}
